import PropTypes from 'prop-types'
import styles from './container.module.scss'
import { useModifiers } from 'hooks/useModifiers'

const Container = ({ children, className = '', noPadding, flex, ...rest }) => {
  const modList = {}
  if (noPadding) {
    modList[`noPadding-${noPadding}`] = true
  }
  if (flex) {
    modList[`flex-${flex}`] = true
  }
  const mods = useModifiers(styles, 'container', modList)
  return (
    <div className={`${styles.container} ${mods} ${className}`} {...rest}>
      {children}
    </div>
  )
}

Container.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
  className: PropTypes.string,
  noPadding: PropTypes.string,
  flex: PropTypes.string,
}

export { Container }
